import styled from "styled-components";

const SegmentationDetailImage = styled.img`
  height: 72px;
  width: 72px;
`;

export default SegmentationDetailImage;



// WEBPACK FOOTER //
// ./src/components/ElementSelector/Common/SegmentationDetailImage.tsx